import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { UserRole } from '../../types/user';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requireAdmin = false }) => {
  // Utiliser uniquement le state Redux pour l'authentification
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  
  // Si l'utilisateur n'est pas authentifié, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Si la route nécessite un admin et que l'utilisateur n'est pas admin, rediriger vers la page d'accueil
  if (requireAdmin && user?.role !== UserRole.ADMIN) {
    return <Navigate to="/" />;
  }

  // Si l'utilisateur est authentifié mais inactif, rediriger vers l'onboarding (sauf s'il y est déjà)
  if (user && user.status !== 'active' && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  // Si tout est OK, afficher le contenu de la route
  return <Outlet />;
};

export default ProtectedRoute;
